<script>
    import {http} from '@/system/http.js';
    import EventCard from '@/online_booking/new/components/events/EventCard.vue';
    import EventCourseCard from '@/online_booking/new/components/events/EventCourseCard.vue';
    import Switchery from '@/system/components/global/form/Switchery';

    import VueSelect from '@/system/components/global/form/VueSelect';
    import {mapGetters} from 'vuex';
    let serverTimeFormat = 'YYYY-MM-DD HH:mm:ss';
    const ONE_HOUR = 60 * 60 * 1000;

    export default {

        components: {
            EventCard,
            EventCourseCard,
            Switchery,
            VueSelect,
        },

        data() {
            return {
                loading: false,
                events_overview_slug: events_overview_slug,
                hideSoldOut: false,
                filter: null,
                selectedTags: [],
            }
        },

        props: ['slug'],

        mounted() {
            this.init();
        },

        methods: {
            init() {
                if (this.eventsLoadedAt && (new Date() - this.eventsLoadedAt) < ONE_HOUR) {
                    // Only load the events once an hour
                    return;
                }

                this.loading = true;
                http.get('/overview/' + this.events_overview_slug + "/get")
                    .then(({ data }) => {
                        this.loading = false;
                        this.$store.commit('setAllEvents', data.all_events);
                        this.$store.commit('setEventTags', data.event_tags);
                        this.$store.commit('setEventsLoadedAt', new Date());
                        this.$store.commit('setWaitingListEnabled', data.is_waiting_list_enabled);
                    })
                    .catch(() => {
                        this.loading = false;
                        this.$store.commit('setAllEvents', []);
                        this.$store.commit('setEventsLoadedAt', null);
                    });
            },

            formattedDate(datetime) {
                return moment(datetime, serverTimeFormat).locale(moment_locale).format('LL');
            },

            getMonth(month) {
                return moment(month, "YYYY-MM").locale(moment_locale).format('MMMM, YYYY')
            },

            showSoldOut(event) {
                if (this.hideSoldOut && (event.available_spots == 0 || !event.is_open)) {
                    return false;
                } else {
                    return true;
                }
            }
        },

        computed: {
            ...mapGetters(['allEvents', 'eventsLoadedAt', 'isWaitingListEnabled', 'eventTags']),
            monthsSorted() {
                if (!this.allEvents || this.allEvents.length <= 0) {
                    return [];
                }
                return Object.keys(this.allEvents).sort();
            },

            filtered_events() {
                let eventsSorted = {};

                for (let month in this.allEvents) {
                    if (!this.filter || this.filter == month) {
                        let eventsFiltered = this.allEvents[month].filter(event => {
                            // filter for hiding sold out events, so if there are 0 spots left, the backend automatically sets is_open to false
                            if (this.hideSoldOut && !event.is_open) {
                                return false;
                            }
                            if (this.selectedTags.length > 0) {
                                return event.tags.some(tag => this.selectedTags.some(t => tag.id === t.id))
                            }
                            return true;
                        });

                        if (eventsFiltered.length > 0) {
                            eventsSorted[month] = eventsFiltered;
                        }
                    }
                }

                return eventsSorted;
            },

            is_showing_months() {
              return Object.keys(this.filtered_events).length > 0;
            }
        }
    };


</script>


<template>
    <div>
        <div class=" text-center" v-if="loading">
            <div class="preloader"></div>
        </div>

        <div v-show="!loading">

            <ep-banner v-if="allEvents.length === 0">
                {{ trans('events.no_future_events') }}
            </ep-banner>

            <div v-else>
                <div class="events-header">
                    <h2 class="events-title">{{ trans('events.future_events') }}</h2>

                  <div class="row flex flex-column items-center sm:flex-row gap-y-6">
                      <div class="col-sm-4 col-xs-12">
                          <select class="form-control w-full" v-model="filter">
                              <option value="" disabled selected>{{ trans('events.select_month') }}</option>
                              <option :value="null">{{ trans('events.view_all_months') }}</option>
                              <option v-for="month in monthsSorted" :value="month" :key="month">{{ getMonth(month) }}</option>
                          </select>
                      </div>

                    <div class="col-sm-4 col-xs-12">
                        <vue-select
                            :options="eventTags"
                            :placeholder="trans('events.tags.filter_by_tag')"
                            v-model="selectedTags"
                            labelField="name"
                        >
                        </vue-select>
                    </div>

                      <div class="col-sm-4 col-xs-12">
                          <switchery :text="trans('events.spots_toggle')" name="spots_toggle" class="m-l-5" :value="hideSoldOut" v-model="hideSoldOut" :light="true" active-color="var(--brand-primary)"></switchery>
                      </div>
                  </div>
              </div>

                <div class="events-overview">

                    <h4 v-if="!is_showing_months">{{ trans('events.no_future_events_for_search') }}</h4>

                    <template v-for="month in monthsSorted" v-else>

                        <h3
                            v-if="filtered_events[month] && filtered_events[month].length > 0"
                            class="events-month-overview text-blue-800"
                            :class="{'m-t-30': month != monthsSorted[0]}"
                            :key="month"
                        >
                            {{ $filters.capitalize(getMonth(month)) }}
                        </h3>
                        <div class="row flex flex-wrap gap-y-7">
                            <div
                                class="col-md-4 col-sm-6 col-xs-12"
                                v-for="event in filtered_events[month]"
                            >
                                <template
                                    v-if="event.type === 'event'"
                                >
                                    <event-card
                                        :hoverable="true"
                                        :event="event"
                                        :fullDescription="false"
                                        :is_waiting_list_enabled="isWaitingListEnabled"
                                        v-if="showSoldOut(event)"
                                        :key="event.id"
                                    ></event-card>
                                </template>
                                <template v-else>
                                    <event-course-card :eventGroup="event" :hoverable="true" :fullDescription="false" :is_waiting_list_enabled="isWaitingListEnabled" v-if="showSoldOut(event)" :key="event.id"></event-course-card>
                                </template>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    .switchery {
        background-color: #f5f5f5;
        border-color: #dedede;
    }

    .form-group.switch-group {
        margin: 0;
    }

    .event-card-wrapper {
        width: 100%;
        margin-bottom: 0;
        height: 100%;
    }

</style>
